import { notification } from "antd"

import { notificationOptions } from "../../constants/notification.config"
import type { SaveResult } from "../../redux/shared/types"

type HandleSaveResult = SaveResult | string | null | undefined
type SaveResultMessage = {
  message?: string
  description?: string
}

function getMessage(saveResult: HandleSaveResult): SaveResultMessage | null {
  if (typeof saveResult === "string") {
    return { message: saveResult }
  }

  if (typeof saveResult === "object" && saveResult?.message) {
    return saveResult
  }

  return null
}

export function handleSaveResult(
  saveResult: HandleSaveResult,
  defaultMessage?: string
) {
  const data = getMessage(saveResult) || {
    message: defaultMessage
  }

  if (!data?.message) return

  notification?.success({
    ...notificationOptions.success,
    message: data?.message,
    description: data?.description
  })
}
